import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const blogs = [
    { id: 12, title: 'Korsika', image: '/images/Dashboard/Korsika_Flagge.png', link: '/korsika' },
    { id: 11, title: 'Schweden 2025/2026', image: '/images/Dashboard/Schweden2026.jpeg', link: '/schweden2026' },
    { id: 10, title: 'Thailand 2025', image: '/images/Dashboard/Thailand_2025.jpg', link: '/thailand2025' },
    { id: 9, title: 'Schottland', image: '/images/Dashboard/SchottlandFlagge.png', link: '/schottland' },
    { id: 8, title: 'Schweden', image: '/images/Dashboard/Schweden2025_Jan.jpg', link: '/schweden' },
    { id: 7, title: 'Norwegen', image: '/images/Dashboard/Norwegen.jpg', link: '/norwegen' },
    { id: 6, title: 'Zandvoort', image: '/images/Dashboard/Zandvoort.jpg', link: '/zandvoort' },
    { id: 5, title: 'Sri Lanka', image: '/images/Dashboard/SriLanka.jpg', link: '/srilanka' },
    { id: 4, title: 'Thailand', image: '/images/Dashboard/Thailand.jpg', link: '/thailand' },
    { id: 3, title: 'Split', image: '/images/Dashboard/Split.jpg', link: '/split' },
    { id: 2, title: 'Mauritius', image: '/images/Dashboard/Mauritius.jpg', link: '/mauritius' },
    { id: 1, title: 'Belize', image: '/images/Dashboard/Belize.jpg', link: '/belize' },
];

const LinksToBlog = () => {
    const [visible, setVisible] = useState([]);

    useEffect(() => {
        const handleScroll = () => {
            const newVisible = blogs.map((_, index) => {
                const el = document.getElementById(`blog-${index}`);
                if (!el) return false;

                const rect = el.getBoundingClientRect();
                return rect.top < window.innerHeight - 100;
            });

            setVisible(newVisible);
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <section className="blog-modern">

            <h2 className="blog-heading">Reiseziele</h2>

            <div className="blog-grid">

                {blogs.map((blog, index) => (
                    <Link
                        to={blog.link}
                        key={blog.id}
                        id={`blog-${index}`}
                        className={`blog-card ${visible[index] ? "show" : ""}`}
                    >
                        <img src={blog.image} alt={blog.title} />

                        <div className="blog-overlay">
                            <h3>{blog.title}</h3>
                        </div>
                    </Link>
                ))}

            </div>

        </section>
    );
};

export default LinksToBlog;